import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
import { CommonTypeSchema } from './CommonType';
export const actionSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    device_id: integerInRange(0, 0xffffffff),
    title: v.string(),
    type: CommonTypeSchema
});
